import React, { useState } from 'react';


function Header() {
  return (
    <>
        <header className="header fix-block">
            <div className="header__content container">
            <a href="/" className="header__logo">
                <picture>
                <source srcSet="/img/logo.avif" type="image/avif" />
                <source srcSet="/img/logo.webp" type="image/webp" />
                <img loading="lazy" src="/img/logo.png" alt="логотип" />
                </picture>
            </a>
            <p className="header__text">
                Центр раннего развития детей «TopKids»
            </p>
            <div className="contacts-box header__contacts">
                <a href="tel:+79145866771" className="contacts-box__tel">
                +7 914 586 67 71
                </a>
                <button
                data-hystmodal="#order-call"
                className="contacts-box__callback btn-reset"
                >
                Заказать звонок
                </button>
            </div>
            </div>
        </header>
    </>
  );
}

export default Header;
